import { Toolbar } from '@mui/material'
import React, { useState } from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import { DataTable, FilterSection, SelectField, ToolbarComponent } from '../../../../../components'
import { useGlobal } from '../../../../../shared'
import { urls } from '../../../../../shared/config'
import { useSelector } from 'react-redux'

// import { ImportIcon } from '../../../../../assets/icons'

import { HolidayHeadCells } from '../../../../../shared/data/headCells'

import HolidayPopUp from './PopOver/HolidayPopUp'
import { EditHoliday } from './component/EditHoliday'
import { HolidayDetail } from './component/HolidayDetail'
import { InfoField } from '../School/PopOver/SchoolInfo'
// import { setOpenImport } from '../../../../../redux/globalSlice'
import { highestInt } from '../../../../../shared/utils/constants'
import { ImportIcon } from '../../../../../assets/icons'
import { downloadCSV } from '../../../../../shared/config/downloadCSV'

const Holidays = () => {
  const [page, setPage] = useState(1)
  const rowsPerPage = useSelector((state) => state.global.rowsPerPage)

  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type
  const [schoolName, setSchoolName] = React.useState('')
  const [openholidayInfo, setHolidayInfo] = useState(false)
  const [search, setSearch] = useState('')
  const {
    data: holidayList,
    count,
    refetch,
  } = useGlobal({
    userUrl: `${urls.HOLIDAY_GET}?school_id=${schoolName ? schoolName : userSchoolId}&page=${page}&limit=${rowsPerPage}`,
    // userUrl: `${urls.HOLIDAY_GET}?school_id=${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : ''}`,
  })
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  // const dispatch = useDispatch()
  // const { data: searchstudent } = useGlobal({
  //   userUrl: `${urls.STUDENT_SEARCH}${search}&grade_id=${'asdas'}&fee_status=${'asd'}&school_id=${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : ''}`,
  // })
  const [update, setUpdate] = useState(false)
  const [detail, setDetail] = useState(false)
  //   const rowData = search || gradeValue || feeStatus ? searchstudent : studentRow
  const handleOpen = () => {
    setHolidayInfo(true)
  }

  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name
  const no_data_msg =
    customRole == 'Admin'
      ? 'Add Holiday to start over'
      : schoolName
        ? 'Add Holiday to start over'
        : 'Select school to see Holiday'

  const handleExport = () => {
    if (holidayList && holidayList?.length > 0) {
      // Generate filename with current date
      const date = new Date().toISOString().split('T')[0]
      const schoolIdentifier = schoolName
        ? schoolList?.find((s) => s.school_id === schoolName)?.school_name || 'Holidays'
        : 'Holidays'
      downloadCSV(holidayList, `${schoolIdentifier}_${date}`)
    } else {
      alert('No data to export')
    }
  }
  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Holidays'} subtitle={'Dashboard / Holidays'} />
      <div className="school-toolbar">
        <div style={{ width: '40%' }}>
          {customRole != 'Admin' ? (
            <SelectField
              placeholder={'Select School'}
              options={(schoolList || [])?.map((prod) => ({
                value: prod.school_id,
                label: prod.school_name,
              }))}
              name="schoolName"
              value={schoolName}
              onChange={(selectedOption) => {
                setSchoolName(selectedOption)
                setPage(1)
              }}
            />
          ) : (
            <InfoField value={userSchoolName} />
          )}
        </div>
      </div>
      <ToolbarComponent handleOpen={handleOpen} search={search} holidays setSearchItem={setSearch}>
        {/* <FilterStudent
          teachers={teachers}
          setTeachers={setTeachers}
          vanDriver={vanDriver}
          setVanDriver={setVanDriver}
          teacherFilter={true}
        /> */}
        {/* <ExportFile icon={FilterIcon} filename={'student'} jsonData={studentRow || []} /> */}
        <FilterSection icon={ImportIcon} onClick={handleExport} title={'Export'} />
      </ToolbarComponent>

      {search ? (
        <p>No Holidayy Found!</p>
      ) : (
        <DataTable
          headCells={HolidayHeadCells}
          rowData={holidayList}
          holidays={true}
          pageFee={page}
          setPageFee={setPage}
          pages
          school={false}
          noDataMsg={no_data_msg}
          search={search}
          pageCount={count}
          setUpdate={setUpdate}
          handleDetailOpen={() => setDetail(true)}
          refetch={refetch}
        />
      )}
      {openholidayInfo && (
        <HolidayPopUp
          customRole={customRole}
          userSchoolId={userSchoolId}
          open={openholidayInfo}
          handleClose={() => setHolidayInfo(false)}
          title={'Holiday Information'}
        />
      )}
      {update && <EditHoliday open={update} handleClose={() => setUpdate(false)} />}
      {detail && <HolidayDetail open={detail} handleClose={() => setDetail(false)} />}
    </div>
  )
}

export default Holidays
